module.exports = __webpack_public_path__ + "img/TDSouthAfrica-logo.66b3f703.png";